<template>
    <section class="mobile-nav-wrapper">
        <div class="mobile-nav">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <section class="navbar">
                            <div class="nav-controls">
                                <button
                                    @click="mobileNavStore.toggleNav(true)"
                                    type="button"
                                    class="btn-nav--round">
                                    <svgComponent
                                        :width="24"
                                        :height="24"
                                        class-name="icon-hamburger"
                                        icon-name="icon-hamburger"></svgComponent>
                                </button>

                                <button
                                    @click="mobileNavStore.toggleSearchNav()"
                                    type="button"
                                    class="btn-nav--round">
                                    <svgComponent
                                        :width="24"
                                        :height="24"
                                        class-name="icon-search"
                                        icon-name="icon-search"></svgComponent>
                                </button>
                            </div>
                            <a href="/" class="nav-brand">
                                <svgComponent
                                    :width="72"
                                    :height="72"
                                    class-name="nav-brand__logo"
                                    icon-name="knhs-logo"></svgComponent>
                            </a>
                        </section>
                    </div>
                </div>
            </div>
        </div>

        <search-panel></search-panel>
    </section>
    <mobile-navigation
        :navigation="navigation"
        :secondaryNav="secondaryNav"
        :knhsbutton="knhsbutton"
        :contactbutton="contactbutton"></mobile-navigation>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import svgComponent from '../../components/svgComponent.vue';
import mobileNavigation from './components/mobileNavigation.component.vue';
import searchPanel from './components/searchPanel.component.vue';
import { INavigation, ILink, IButtonLink, IPopularLink } from '../../interfaces/Navigation';
import { useMobileNavStore } from './store/mobile-nav.store';
const mobileNavStore = useMobileNavStore();

const props = defineProps<{
    navigation: INavigation[];
    navType: string;
    secondaryNav: ILink;
    knhsbutton: IButtonLink;
    contactbutton: IButtonLink;
    popularTopics: IPopularLink[];
}>();

mobileNavStore.$subscribe((_mutation, state) => {
    state.mobileNavIsOpen
        ? document.body.classList.add('hide-overflow')
        : document.body.classList.remove('hide-overflow');
});

mobileNavStore.setPopularTopics(props.popularTopics);

onMounted(() => {
    const type = props.navigation.find((x) => x.Active);
    let navType = 'Ruiter';

    if (type) {
        navType = type.Type;
    }

    mobileNavStore.setNavigationType(navType);
});
</script>
